import { removeDuplicates, Person, PersonResponse } from "./base";
import request from "./request";

export enum PersonRole {
  TRAINER = "trainer",
  INSTRUCTOR = "instructor",
  ASSESSOR = "assessor",
  CHECKER = "checker",
}

export interface PersonWithRoleResponse extends PersonResponse {
  roleCode: string;
  roleID: number;
}

export class PersonWithRole extends Person {
  public roleCode: PersonRole;
  public roleID: number;

  constructor(data: PersonWithRoleResponse) {
    super(data);
    this.roleCode = data.roleCode as PersonRole;
    this.roleID = data.roleID;
  }
}

export const getAllEvaluators = async (): Promise<PersonWithRole[]> => {
  const response = await request(`/user/trainers/`);
  return response.map((data: PersonWithRoleResponse) => new PersonWithRole(data));
};

export const filterPersonsByRole = (persons: PersonWithRole[], role: PersonRole): PersonWithRole[] => {
  return removeDuplicates(persons.filter((person) => person.roleCode === role));
};
